exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".entity-tag-editor-modal .preview {\n  background-color: var(--color-accent-g2);\n}\n.entity-tag-editor-modal .preview .marked,\n.entity-tag-editor-modal .preview [marked] {\n  padding-top: 5px;\n}\n.entity-tag-editor-modal label .marked p,\n.entity-tag-editor-modal label [marked] p {\n  margin-bottom: 0;\n}\n", ""]);

